import {useIntl} from "react-intl";
import styles from "./index.module.scss";

const View = ({
  videoRef,
  countDown,
  mediaData,
  isPlayMode,
  isVideoHidden,
  isShowSkipBtn,
  hideVideo,
  onClickLogo,
  onLoadedMetadata,
  onTimeUpdate,
  onClickVideo,
  onClickSkipBtn,
}) => {
  const intl = useIntl();
  return isPlayMode && mediaData ? (
    <div className={`${styles.bumper_ad} ${isVideoHidden ? styles.hide : ""}`}>
      <div className={styles.bumper_ad_video_wrap}>
        <img className={styles.bumper_ad_logo} src={mediaData.logoPath} alt="logo" onClick={onClickLogo} />
        <video
          src={mediaData.mediafile_src}
          ref={videoRef}
          className={styles.bumper_ad_test}
          autoPlay
          muted
          playsInline
          controls
          disablePictureInPicture
          controlsList="nodownload noplaybackrate"
          onLoadedMetadata={onLoadedMetadata}
          onTimeUpdate={onTimeUpdate}
          onClick={onClickVideo}
          onEnded={hideVideo}
        />
        {isShowSkipBtn ? (
          <button className={styles.bumper_skip_btn} type="button" onClick={onClickSkipBtn}>
            {intl.formatMessage({id: "ID_BUMPER_AD_SKIP_BTN"})}
          </button>
        ) : (
          <p className={styles.bumper_info}>
            {intl.formatMessage(
              {id: "ID_BUMPER_AD_INFO"},
              {
                count: countDown,
              },
            )}
          </p>
        )}
      </div>
    </div>
  ) : null;
};

export default View;
